<template>
  <router-view />
</template>

<script>
export default {
  name: "service"
};
</script>